import fuzzysort, { type KeysOptions } from "fuzzysort";

export const fuzzySearch = <T>(query: string, items: T[], keys: KeysOptions<T>["keys"]) => {
  const results: T[] = [];
  let totalScore = 0;
  fuzzysort.go<T>(query, items, { keys, limit: 1000, threshold: 0.5 }).forEach(({ obj, score }) => {
    results.push(obj);
    totalScore += score;
  });
  return { results, score: totalScore / results.length };
};
